import PropTypes from 'prop-types';
import { Fragment, useState, useCallback } from 'react';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import NavGroup from 'settings-ui-nav/components/NavGroup';
import { expandedSettingsKey, getSessionSetting, setSessionSetting } from 'settings-ui-nav/utils/storageSettings';
import NavItemRecord from 'settings-ui-nav/utils/NavItem';
import { jsx as _jsx } from "react/jsx-runtime";
const cachedOpenItems = getSessionSetting(expandedSettingsKey) || {};
const SideNav = ({
  config,
  onItemClick,
  pathname,
  settingsApp,
  track,
  hasStagedChanges,
  hasFirstGroup
}) => {
  const [openItems, setOpenItems] = useState(cachedOpenItems);
  const handleOpenClick = useCallback((itemKey, open) => {
    const updatedOpenItems = Object.assign({}, openItems);
    if (open) {
      updatedOpenItems[itemKey] = true;
    } else {
      delete updatedOpenItems[itemKey];
    }
    setSessionSetting(expandedSettingsKey, updatedOpenItems);
    setOpenItems(updatedOpenItems);
  }, [openItems]);
  if (config.length) {
    return /*#__PURE__*/_jsx(Fragment, {
      children: config.map((navGroup, index) => {
        return /*#__PURE__*/_jsx(NavGroup, {
          isFirstGroup: hasFirstGroup && index === 0,
          openItems: openItems,
          onOpenClick: handleOpenClick,
          config: navGroup,
          onItemClick: onItemClick,
          pathname: pathname,
          settingsApp: settingsApp,
          track: track,
          hasStagedChanges: hasStagedChanges
        }, navGroup.id);
      })
    });
  }
  return /*#__PURE__*/_jsx(LoadingSpinner, {});
};
SideNav.propTypes = {
  config: PropTypes.arrayOf(PropTypes.instanceOf(NavItemRecord).isRequired).isRequired,
  onItemClick: PropTypes.func,
  pathname: PropTypes.string.isRequired,
  settingsApp: PropTypes.string,
  track: PropTypes.func.isRequired,
  hasStagedChanges: PropTypes.bool,
  hasFirstGroup: PropTypes.bool
};
export default SideNav;